import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Flex } from '@rebass/grid';
import Button from '../../atoms/Button';
import Text from '../../atoms/Text';
import Stamp from '../../molecules/Stamp';
import StampScanner from '../../molecules/StampScanner';
import { addUserStamp, getUserStamps } from '../../../api/stamp';
import { withAuth } from '../../../context/auth';
import { withLoading } from '../../../context/loading';
import { withStampData } from '../../../context/stampData';
import { getStampCollectionId, getUserStatus, isDateValid } from '../../../utils/common';
import stamp1 from '../../../assets/images/stamp_1.png';
import stamp2 from '../../../assets/images/stamp_2.png';
import stamp3 from '../../../assets/images/stamp_3.png';
import stamp4 from '../../../assets/images/stamp_4.png';
import stamp5 from '../../../assets/images/stamp_5.png';
import stamp6 from '../../../assets/images/stamp_6.png';

const stampsTW = [
  { id: '228b7fc0-0ff0-4a8b-b787-91f4516a2b48', image: stamp3 },
  { id: '3e34218b-c219-4f0e-bbf1-79bcb9ea5b11', image: stamp4 },
  { id: '9e78d964-c95e-4c1c-88cc-901d82290f42', image: stamp6 },
];

const stampsYL = [
  { id: 'a376637d-7965-449d-b60a-0e4dbf7c55b3', image: stamp5 },
  { id: 'ab67bcd1-5e89-42aa-8c58-03f6ee2a0006', image: stamp1 },
  { id: 'e8cfb266-cc65-407f-95c1-6e9fae12aa80', image: stamp2 },
];

const Container = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 22px;
`;

class HomePage extends React.Component {
  constructor() {
    super();
    this.state = {
      cameraOpen: false,
    };
  }

  setCameraOpen = (isOpen) => {
    this.setState({ cameraOpen: isOpen });
  }

  fetchUserStampsFromApi = () => {
    const { auth, setAuth, appType, stampCollection, setUserStamps } = this.props;
    const stampCollectionId = getStampCollectionId(appType);
    const params = {
      'stamp_template/stamp_collection': stampCollectionId,
    };
    return getUserStamps(params, auth, setAuth)
      .then(({ data: userStamps }) => {
        setUserStamps(userStamps);
        const userStatus = getUserStatus(stampCollection, userStamps);
        if (userStatus !== auth.user.status) {
          const updatedUser = { ...auth.user, status: userStatus };
          setAuth({ ...auth, user: updatedUser });
        }
      });
  }

  onStampScanned = (stampValue) => {
    const { auth, setAuth, setLoading } = this.props;
    setLoading(true);
    addUserStamp(stampValue, auth, setAuth)
      .then(() => this.fetchUserStampsFromApi())
      .then(() => {
        this.setCameraOpen(false);
      })
      .catch((err) => {
        alert(err.message);
      })
      .finally(() => setLoading(false));
  }

  onScannerError = (err) => {
    this.setCameraOpen(false);
    alert('Your browser may not support the required function, Please switch to another browser to continue.\nFor iOS users, it is required to use Safari.');
  }

  render() {
    const { appType, userStamps } = this.props;
    const { cameraOpen  } = this.state;
    const redeemAddress = appType === 'kolour_tw' ? 'I 期地下大門(電訊數碼旁)' : '地下禮賓部旁';
    const location = appType === 'kolour_tw' ? '荃灣千色匯' : '元朗千色匯';
    return (
      <Container>
        <Text variant="h2" align="center">尋找NINA及白熊與男孩</Text>
        <Text variant="h2" align="center">換領商場優惠券</Text>
        <Flex flexDirection="column" justifyContent="flex-start" width={1} flexShrink="0" mt="0.8rem" >
          <Flex>
            <Text variant="body1" shadow>換領日期：</Text>
            <Text variant="body1" shadow>2020年11月23日至2021年1月3日</Text>
          </Flex>
          <Flex>
            <Text variant="body1" shadow>換領時間：</Text>
            <Text variant="body1" shadow>12:00nn - 8:00pm</Text>
          </Flex>
          <Flex>
            <Text variant="body1" shadow>換領地點：</Text>
            <Text variant="body1" shadow>{redeemAddress}</Text>
          </Flex>
          <Flex>
            <Text variant="body1" shadow>活動地點：</Text>
            <Text variant="body1" shadow>{location}</Text>
          </Flex>
        </Flex>
        <Box mt="auto" width={1}>
          <Text shadow>
            顧客登記成為H•COINS會員，於商場內各層參與商戶尋找並集齊3幅圖片，
            即可換領<Text palette="tertiary">{location}HK$50餐飲及HK$50購物優惠券各乙張。</Text>
          </Text>
        </Box>
        <Box mt="0.2rem">
          <Text variant="body2" align="center">(名額1,500套，數量有限，先到先得。以親身換領時間計算)</Text>
        </Box>
        <Flex mt="0.6rem" flexShrink="0">
          <Button color="tertiary" onClick={() => this.setCameraOpen(true)} disabled={!isDateValid()}>
            <Text palette="secondary" variant="h3">按此掃描圖案</Text>
          </Button>
        </Flex>
        <Flex mt="0.5rem" justifyContent="space-around" width={1} flexShrink="0">
          {(appType === 'kolour_tw' ? stampsTW : stampsYL).map(stamp => {
            const { id, image } = stamp;
            const matchedUserStamp = userStamps.find(userStamp => userStamp.stamp_template === id);
            return (
              <Stamp key={id} src={image} size="27vw" stamped={!!matchedUserStamp} style={{ maxWidth: '10rem', maxHeight: '10rem' }} />
            );
          })}
        </Flex>
        <Flex justifyContent="space-between" width={1} mt="0.5rem">
          <Text fontType="tertiary" variant="body2">每位H•COINS會員只可換領乙套</Text>
          <Text fontType="tertiary" variant="body2">*條款及細則適用</Text>
        </Flex>
        {cameraOpen && (
          <StampScanner
            onScanned={this.onStampScanned}
            onClose={() => this.setCameraOpen(false)}
            onError={this.onScannerError}
            appType={appType}
          />
        )}
      </Container>
    );
  }
}

HomePage.propTypes = {
  auth: PropTypes.object,
  setAuth: PropTypes.func,
  appType: PropTypes.string,
  stampCollection: PropTypes.object,
  userStamps: PropTypes.array,
  setUserStamps: PropTypes.func,
  setLoading: PropTypes.func,
};

HomePage.defaultProps = {
  auth: null,
  setAuth: () => {},
  appType: 'kolour_tw',
  stampCollection: null,
  userStamps: [],
  setUserStamps: () => {},
  setLoading: () => {},
};

export default withAuth(withLoading(withStampData(HomePage)));
